<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-2">
              <router-link  to="/">
                {{$t('propertydetails.breadcrumb_1')}}
              </router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li v-if="management" class="almarai-bold mx-2">
              <router-link to="/propertie">
                {{$t('property.breadcrumb_2')}}
              </router-link>
            </li>
            <i  v-if="management && userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <!-- <i  v-else class="fa-solid fa-chevron-right pt-1"></i> -->
            <li class="active mx-2 almarai-bold" aria-current="page">{{$t('propertydetails.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>

  <div class="container pt-3">
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />

    <div class="text-center" v-if="isLoading">
      <mainloader />
    </div>

    <div v-else class="row">
      <div class="col">
        <div class="row pt-3 justify-content-center">
          <div class="col text-center algin-content-center">
            <swiper v-if="value.property && value.property.mediaFiles.length" :modules="modules" :pagination="{ clickable: true }" :spaceBetween="10"
              :thumbs="{ swiper: thumbsSwiper }" :navigation="true" :autoplay="{ delay: 2500, disableOnInteraction: false,}"
              :style="{'--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff',}" class="br-radius"
            >
              <swiper-slide style="position:relative" v-for="(gllary, index) in value.property.mediaFiles" :key="index">
                <span class="favorite" v-if="value.property.Favorites && value.property.Favorites.length" @click.prevent="removeFavorite(value.property.id, 'value.property.mediaFiles', index)">
                  <i class="fa-solid fa-heart favorite-icon"></i>
                </span>
                <span  class="favorite" v-else @click.prevent="addFavorite(value.property.id, 'value.property.mediaFiles', index)">
                  <i class="fa-solid fa-heart favorite-icon-remove"></i>
                </span>
                <span class="share-nodes">
                  <a :href="`https://wa.me/?text=${encodeURIComponent(whatsAppTextPublic)}`">
                    <!-- <img src="/assets/images/share-nodes.png" class="max-30" alt=""> -->
                    <i class="bi bi-share-fill font-20 font-color-AA"></i>
                  </a>
                </span>

                <img :src="MEDIA_URL+gllary.filePath" @click="openLightbox(index)" alt="Slide Image" class="swiper-img" />
              </swiper-slide>
            </swiper>
            <div v-else>
              <placeHolder />
            </div>

            <FsLightbox
              :toggler="lightboxToggler"
              :sources="images"
              :slide="lightboxIndex + 1"
            />

            <swiper v-if="value.property && value.property.mediaFiles.length" @swiper="setThumbsSwiper" :spaceBetween="10" :slidesPerView="4" 
              :freeMode="true"
              :watchSlidesProgress="true"
              :modules="modules"
              class="pt-3 mouse-hand"
            >
              <swiper-slide v-for="(image,indx) in value.property.mediaFiles" :key="indx">
                <img :src="MEDIA_URL+image.thumbnail" class="img-fluid br-radius" alt="">
              </swiper-slide>
            </swiper>

            <swiper v-else @swiper="setThumbsSwiper" :spaceBetween="10" :slidesPerView="4" 
              :freeMode="true"
              :watchSlidesProgress="true"
              :modules="modules"
              class="pt-3 mouse-hand"
            >
              <swiper-slide>
                <placeHolder />
              </swiper-slide>
            </swiper>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col">
            <div class="row" v-if="!myadvertisement && !management">
              <div class="col" v-if="purpose">
                <img src="/assets/images/icons/tag.png" class="max-24" alt="">
                <span class="font-color-AA mx-2 fonttext-14">
                  {{(value.property.purpose == 'for_rent')? $t('propertydetails.title_25') : (value.property.purpose == 'for_sale')?  $t('propertydetails.title_1') : $t('propertydetails.title_26')}}
                </span>
              </div>
              <!-- <div class="col-auto" v-if="adLicenseNumber"> 
                <label>{{$t('propertydetails.licenseNumber')}}</label>
                <div>{{adLicenseNumber}}</div>
              </div> -->
            </div>

            <div class="row pt-3" v-if="!isLoading">
              <div class="col-12 col-md-8 button-center">
                <div v-if="value.property && value.property.title" class="fonttext-14 almarai-regular">{{value.property.title}}</div>
                <div class="gray-color d-flex fonttext-14 pt-2">
                  <i class="fa-solid fa-location-dot"></i>
                  <span v-if="value.property && value.property.Neighborhood?.name" class="mx-2">
                    {{value.property.Neighborhood.name}}
                  </span>
                  <div v-if="value.property && value.property.City?.name">
                    {{value.property.City.name}}
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 text-center" v-if="propertyAdditional && propertyAdditional.roiReportPath">
                <a :href="MEDIA_URL+propertyAdditional.roiReportPath" target="_blank">
                  <div class="investmentProperty">
                    <img src="/assets/images/icons/moneys.png" class="max-24" alt="">
                    <span class="mx-2">{{$t('investmentProperty')}}</span>
                  </div>
                </a>
              </div>
            </div>
            <hr class="line-color">

            <div class="row pt-2" v-if="management || myadvertisement">
              <div class="col-auto ps-0">
                <img src="/assets/images/icons/Frame-8.png" class="max-42" alt="">
              </div>
              <div class="col propertyStatus">
                <h6 class="almarai-regular mb-0 fonttext-14 gray-color">
                  {{$t('rentalDetails.title_1')}}
                </h6>
                <div class="text-style-green font-12">{{value.statusChoices[value.property.status]}}</div>
              </div>
            </div>

            <!-- <div class="row countedIcons pt-4" v-if="!isLoading">
              <div class="col-2 col-md-1 icons" v-if="value.property.area">
                <div class="padding-Bottom">
                  <img :src="MEDIA_URL+icons.area.path" alt="" class="max-width-28">
                </div>
                <div class="mx-2 icon_style" >{{value.property.area}}</div>
                <div class="icon_style">{{icons.area.name}}</div>
              </div>
              <div class="col-2 col-md-1 icons"  v-if="value.property.age">
                <div class="padding-Bottom">
                  <img :src="MEDIA_URL+icons.age.path" alt="" class="max-width-28">
                </div>
                <div class="mx-2 icon_style">{{value.property.age}}</div>
                <div class="icon_style">{{icons.age.name}}</div>
              </div>
              <div class="col-2 col-md-1 icons" v-if="value.property.roomsCount">
                <div class="padding-Bottom">
                  <img :src="MEDIA_URL+icons.roomsCount.path" alt="" class="max-width-28">
                </div>
                <div class="mx-2 icon_style">{{value.property.roomsCount}}</div>
                <div class="icon_style">{{icons.roomsCount.name}}</div>
              </div>
              <div class="col-2 col-md-1 icons" v-if="value.property.bathrooms">
                <div class="padding-Bottom">
                  <img :src="MEDIA_URL+icons.bathrooms.path" alt="" class="max-width-28">
                </div>
                <div class="mx-2 icon_style">{{value.property.bathrooms}}</div>
                <div class="icon_style">{{icons.bathrooms.name}}</div>
              </div>
            </div> -->

            <div class="row pt-4" v-if="value.property.PropertyFeatures && value.property.PropertyFeatures.length">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <div class="almarai-bold">{{$t('propertydetails.title_2')}}:</div>
                  </div>
                  <div class="col-auto" @click="method_propertyFeatures">
                    <div class="view_All">{{$t('viewAll')}}</div>
                  </div>
                </div>
                <div class="row pt-3 display-card" v-if="propertyFeatures && propertyFeatures.length">
                  <div class="col-auto col-md-3 text-center align-content-center mb-2"
                    v-for="(val,index) in propertyFeatures.slice(0, 4)" :key="index">
                    <div class="card borderCard">
                      <div class="card-body">
                        <div class="row">
                          <div class="col">
                            <div>
                              <img :src="MEDIA_URL+val.icon" class="max-width-28" alt="">
                            </div>
                            <div class="gray-color almarai-regular">{{val.name}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-3" v-if="value.property.description && !management">
              <div class="col-11 col-md-6">
                <h5 class="almarai-bold font-20">{{$t('propertydetails.title_3')}}:</h5>
                <div class="gray-color almarai-regular fonttext-14 pt-2">
                  <div :class="(showMessage) ? 'preLine readLess' :'preLine readMore'">{{value.property.description}}</div>
                  <div @click.prevent="showMessage =!showMessage" class="readMore_Style mx-2">
                    {{showMessage ? 'عرض الاقل' : 'المزيد'}}
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-3 description_Details" v-if="!management">
              <div class="col-12 col-sm-6">
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.region')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{value.property.Region?.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.city')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{value.property.City?.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.neighborhood')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{value.property.Neighborhood?.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('propertydetails.title_4')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{value.property.street ?? ''}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.streetWidth')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{advertisement?.streetWidth}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.propertyType')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{value.property.PropertyType?.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.planNumber')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{advertisement?.planNumber}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('propertydetails.propertyAge')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{advertisement?.propertyAge}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.landNumber')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{advertisement?.landNumber}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.numberOfRooms')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{advertisement?.numberOfRooms}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.propertyArea')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{advertisement?.propertyArea.toFixed(2)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="bg-color-beige d-flex">
                      <div class="col-auto almarai-bold">
                        <span>{{$t('advertisements.propertyFace')}} :</span>
                      </div>
                      <div class="col text-direction">
                        <span>{{advertisement?.propertyFace}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="advertisement && !management" class="row pt-3">
              <div class="col-12 col-md-6">
                <div class="almarai-bold">{{ $t('advertisements.propertyUtilities') }}:</div>
                <div>{{ advertisement.propertyUtilities.join(', ') }}</div>
              </div>
              <div v-if="advertisement.locationDescriptionOnMOJDeed" class="col-12 col-md-6 mt-2">
                <div class="almarai-bold">{{ $t('advertisements.locationDescriptionOnMOJDeed') }}:</div>
                <div>{{ advertisement.locationDescriptionOnMOJDeed }}</div>
              </div>
            </div>

            <!-- <div  class="row pt-3">
              <div class="col-12 almarai-bold"></div>
              <div class="col-12 mt-2"></div>
            </div> -->

            <div class="row pt-2">
              <div class="col">
                <!-- <div class="row pt-3" v-if="Agent">
                  <div class="almarai-bold py-2">{{$t('propertydetails.AdvertiserInformation')}}</div>
                  <div class="col-auto" v-if="Agent.avatar">
                    <div class="agent-logo">
                      <img :src="MEDIA_URL+Agent.avatar" class="w-100" alt="">
                    </div>
                  </div>
                  <div v-else class="col-auto">
                    <div>
                      <i class="fa-solid mouse-hand fa-circle-user img_Default"></i>
                    </div>
                  </div>
                  <div class="col">
                    <div class="almarai-regular">
                      <span>{{Agent.name}}</span>
                      <img src="/assets/images/verify-1.png" class="w-24 me-2" alt="">
                    </div>
                    <span class="almarai-regular agent-color">{{$t('propertydetails.title_10')}}</span>
                  </div>
                  <div class="col-auto  tex-direction content-end">
                    <span class="mx-2">
                      <a :href="'https://wa.me/+966'+Agent.mobile.substring(1)+'?text='+'https://aqaralmuhaysini.com/propertydetails/'+propertyId+'?propertyType=property '+value.property.title+' '+value.property.Neighborhood.name+' '+value.property.City.name">
                        <img src="/assets/images/Frame-whatsapp.png" class="img-fluid" alt="">
                      </a>
                    </span>
                    <span class="mx-2">
                      <a :href="'tel:'+Agent.mobile">
                        <img src="/assets/images/Frame-call.png" class="img-fluid" alt="">
                      </a>
                    </span>
                  </div>
                </div> -->
                <!-- begin:ownerData -->
                <!-- <div class="row pt-3" v-if="adCreator && !myadvertisement && !management">
                  <div class="almarai-bold py-2">{{$t('propertydetails.AdvertiserInformation')}}</div>
                  <div class="col-auto" v-if="adCreator.avatar && !value.property.status == 'rented'">
                    <div class="agent-logo">
                      <img :src="MEDIA_URL+adCreator.avatar" class="w-100" alt="">
                    </div>
                  </div>
                  <div v-else class="col-auto">
                    <div>
                      <i class="fa-solid mouse-hand fa-circle-user img_Default"></i>
                    </div>
                  </div>
                  <div class="col px-0">
                    <div class="almarai-regular">
                      <span>{{adCreator?.name}}</span>
                    </div>
                    <span class="almarai-regular agent-color">{{$t('propertydetails.ownerName')}}</span>
                  </div>
                  <div class="col-auto content-center d-none d-md-block">
                    <span v-if="!value.isOwner">
                      <div class="green-color-F chatWithClient" v-if="!GET_USER">  
                        <router-link to="/login" class="" >
                          <i class="fa-regular fa-comment-dots"></i> 
                          {{ $t('nav.chatWithClient') }}
                        </router-link>
                      </div>
                      <button class="chatWithClient" v-if="GET_USER" :disabled="sendChatDisabled" @click.prevent="sendChatMessage">
                        <i class="fa-regular fa-comment-dots mx-2"></i> 
                        {{ $t('nav.chatWithClient') }}
                      </button>
                    </span>
                  </div>
                  <div class="col-auto">
                    <span class="mx-2" v-if="GET_USER">
                      <a :href="`https://wa.me/+966${parseInt(adCreator.mobile)}?text=${encodeURIComponent(whatsAppTextPrivate)}`" target="_blank" > 
                        <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                      </a>
                    </span>
                    <span v-else @click="poupLogin">
                      <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                    </span>
                    <span class="mx-2">
                      <a :href="'tel:'+adCreator.mobile" target="_blank">
                        <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                      </a>
                    </span>
                  </div>
                </div> -->

                <div v-if="adCreator && myadvertisement" class="row d-block d-md-none pt-3 justify-content-center">
                  <div class="col-12 text-center">
                    <span v-if="!value.isOwner">
                      <router-link to="/login" class="chatWithClient" v-if="!GET_USER">
                        <div class="green-color-F"> 
                          <i class="fa-regular fa-comment-dots"></i> 
                          {{ $t('nav.chatWithClient') }}
                        </div>
                      </router-link>
                      <button class="chatWithClient" v-if="GET_USER" :disabled="sendChatDisabled" @click.prevent="sendChatMessage">
                        <i class="fa-regular fa-comment-dots mx-2"></i> 
                        {{ $t('nav.chatWithClient') }}
                      </button>
                    </span>
                  </div>
                </div>

                <div class="row pt-3" v-if="!management && advertisement">
                  <div class="almarai-bold py-2">{{$t('propertydetails.AdvertiserInformation')}} ({{ advertisement.advertiserName }})</div>
                  <div class="col-auto">
                    <div>
                      <i class="fa-solid mouse-hand fa-circle-user img_Default"></i>
                    </div>
                  </div>
                  <div class="col px-0">
                    <div class="almarai-regular">
                      <span>{{advertisement.responsibleEmployeeName ?? advertisement.advertiserName}}</span>
                      <!-- <img src="/assets/images/verify-1.png" class="w-24 me-2" alt=""> -->
                    </div>
                    <span class="almarai-regular agent-color">{{advertisement.responsibleEmployeePhoneNumber ?? advertisement.phoneNumber}}</span>
                  </div>
                  <div class="col-auto content-center d-none d-md-block">
                    <span v-if="!value.isOwner">
                      <div class="green-color-F chatWithClient" v-if="!GET_USER"> 
                        <router-link to="/login" class="green-color-2BB">
                          <i class="fa-regular fa-comment-dots mx-2"></i> 
                          {{ $t('nav.chatWithClient') }}
                        </router-link>
                      </div>
                      <button class="chatWithClient" v-if="GET_USER" :disabled="sendChatDisabled" @click.prevent="sendChatMessage">
                        <i class="fa-regular fa-comment-dots mx-2"></i> 
                        {{ $t('nav.chatWithClient') }}
                      </button>
                    </span>
                  </div>
                  <div class="col-auto">
                    <span v-if="advertisement.responsibleEmployeePhoneNumber" class="mx-2">
                      <a v-if="GET_USER" :href="`https://wa.me/+966${parseInt(advertisement.responsibleEmployeePhoneNumber)}?text=${encodeURIComponent(whatsAppTextPrivate)}`" target="_blank" > 
                        <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                      </a>
                      <span class="mouse-hand" v-else @click="poupLogin">
                        <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                      </span>
                    </span>
                    <span v-else class="mx-2">
                      <a v-if="GET_USER" :href="`https://wa.me/+966${parseInt(advertisement.phoneNumber)}?text=${encodeURIComponent(whatsAppTextPrivate)}`" target="_blank" > 
                        <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                      </a>
                      <span class="mouse-hand" v-else @click="poupLogin">
                        <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                      </span>
                    </span>
                    <span v-if="advertisement.responsibleEmployeePhoneNumber" class="mx-2">
                      <a :href="'tel:'+advertisement.responsibleEmployeePhoneNumber" target="_blank">
                        <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                      </a>
                    </span>
                    <span v-else class="mx-2">
                      <a :href="'tel:'+advertisement.phoneNumber" target="_blank">
                        <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                      </a>
                    </span>
                  </div>
                </div>
                <div v-if="advertisement" class="row d-block d-md-none pt-3 justify-content-center">
                  <div class="col text-center">
                    <span v-if="!value.isOwner">
                      <router-link to="/login" v-if="!GET_USER" class="green-color-2BB">
                        <div class="green-color-F chatWithClient" > 
                          <i class="fa-regular fa-comment-dots mx-2"></i> 
                          {{ $t('nav.chatWithClient') }}
                        </div>
                      </router-link>
                      <div class="row justify-content-center" v-if="GET_USER">
                        <div class="col-11 chatWithClient">
                          <div class="bg-white" :disabled="sendChatDisabled" @click.prevent="sendChatMessage">
                            <i class="fa-regular fa-comment-dots mx-2"></i> 
                            {{ $t('nav.chatWithClient') }}
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
                <!-- end:ownerData -->
              </div>
            </div>
          </div>
        </div>
        
        <!-- begin:Property details owner -->
        <div class="row" v-if="management && myadvertisement">
          <div class="col">
            <div class="row pt-3">
              <div class="col">
                <!-- <div class="row pt-3">
                  <div class="col-12 col-md-8 button-center">
                    <div v-if="value.property && value.property.title" class="fonttext-14 almarai-regular">{{value.property.title}}</div>
                    <div class="gray-color d-flex fonttext-14 pt-1">
                      <i class="fa-solid fa-location-dot pt-1"></i>
                      <div class="me-1">{{value.property.City.name}}</div>
                      <div class="mx-1">{{value.property.Neighborhood.name}}</div>
                    </div>
                  </div>
                  <div class="col-auto viewDoc">
                    <span class="mx-2">{{$t('property.viewDocuments')}}</span>
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                  </div>
                </div> -->
                <!-- <hr class="line-color"> -->

                <div class="row pt-3">
                  <div class="col">
                    <!-- <div class="row pt-3" v-if="Agent">
                      <div class="almarai-bold py-2">{{$t('propertydetails.AdvertiserInformation')}}</div>
                      <div class="col-3 col-md-auto" v-if="Agent.avatar">
                        <div class="agent-logo">
                          <img :src="MEDIA_URL+Agent.avatar" class="w-100" alt="">
                        </div>
                      </div>
                      <div v-else class="col-3 col-md-auto">
                        <div class="agent-logo">
                          <img src="/assets/images/icons/image.png" class="w-100" alt="">
                        </div>
                      </div>
                      <div class="col-4 col-md-auto content-end">
                        <div class="almarai-regular">
                          <span>{{Agent.name}}</span>
                          <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt="">
                        </div>
                        <span class="almarai-regular agent-color">{{$t('propertydetails.title_10')}}</span>
                      </div>
                      <div class="col content-end text-start">
                        <span class="mx-2">
                          <a :href="'https://wa.me/+966'+Agent.mobile.substring(1)">
                            <img src="/assets/images/Frame-whatsapp.png" class="img-fluid" alt="">
                          </a>
                        </span>
                        <span class="mx-2">
                          <a :href="'tel:'+Agent.mobile">
                            <img src="/assets/images/Frame-call.png" class="img-fluid" alt="">
                          </a>
                        </span>
                      </div>
                    </div> -->

                    <!-- begin:Renter Data -->
                    <div class="row" v-if="value.property.status == 'rented'">
                      <div class="almarai-bold py-2">{{$t('propertydetails.renter')}}</div>
                      <!-- <div class="col-3 col-md-auto" v-if="Agent.avatar">
                        <div class="agent-logo">
                          <img :src="MEDIA_URL+Agent.avatar" class="w-100" alt="">
                        </div>
                      </div> -->
                      <div class="col-3 col-md-auto">
                        <div class="">
                          <!-- <img src="/assets/images/icons/image.png" class="w-100" alt=""> -->
                          <i class="fa-solid mouse-hand fa-circle-user img_Default"></i>
                        </div>
                      </div>
                      <div v-if="User" class="col-4 col-md-auto content-end">
                        <div class="almarai-regular">
                          <span class="almarai-regular agent-color">{{$t('propertydetails.renterName')}}</span>
                          <!-- <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt=""> -->
                        </div>
                        <span>{{User.name}}</span>
                      </div>
                    </div>
                    <!-- end:Renter Data -->

                    <!-- begin:ownerData -->
                    <!-- <div class="row pt-3">
                      <div class="almarai-bold py-2">{{$t('propertydetails.ownerName')}}</div>
                      <div class="col-3 col-md-auto" v-if="adCreator.avatar">
                        <div class="agent-logo">
                          <img :src="MEDIA_URL+adCreator.avatar" class="w-100" alt="">
                        </div>
                      </div>
                      <div v-else class="col-3 col-md-auto">
                        <div class="agent-logo">
                          <img src="/assets/images/icons/image.png" class="w-100" alt="">
                        </div>
                      </div>
                      <div class="col-4 col-md-auto content-end">
                        <div class="almarai-regular">
                          <span>{{adCreator.name}}</span>
                          <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt="">
                        </div>
                        <span class="almarai-regular agent-color">{{$t('propertydetails.ownerName')}}</span>
                      </div>
                      <div class="col text-start content-end">
                        <span class="mx-2">
                          <a :href="'https://wa.me/+966'+adCreator.mobile.substring(1)">
                            <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                          </a>
                        </span>
                        <span class="mx-2">
                          <a :href="'tel:'+adCreator.mobile">
                            <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                          </a>
                        </span>
                      </div>
                    </div> -->
                    <!-- end:ownerData -->
                  </div>
                </div>
              </div>
            </div>
            <h6 
              v-if="(value.property.collectedAmount && parseFloat(value.property.collectedAmount)) || (value.property.remainingPayments && parseFloat(value.property.remainingPayments)) || value.property.rentalTerm || (value.property.totalDueAmount && parseFloat(value.property.totalDueAmount)) || value.property.rentExpire"
              class="almarai-bold pt-4">{{$t('rentalDetails.title_2')}}</h6>
            <div class="row pt-3 justify-content-between" v-if="!isLoading">
              <div class="col" v-if="value.property.collectedAmount && parseFloat(value.property.collectedAmount)">
                <div class="row pt-2">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-8.png" class="width-48" alt="">
                  </div>
                  <div class="col">
                    <span class="text-style">{{$t('rentalDetails.PayingRent')}}</span><br>
                    <span class="green-2B almarai-bold">{{value.property.collectedAmount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
              <div class="col" v-if="value.property.remainingPayments && parseFloat(value.property.remainingPayments)">
                <div class="row">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-5.png" class="width-48" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('rentalDetails.title_4')}}</span><br>
                    <span class="gray-color-60 almarai-bold">{{value.property.remainingPayments}} <span class="mx-1 icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row py-4" v-if="!isLoading">
              <div class="col" v-if="value.property.rentalTerm">
                <div class="row">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-calendar-2.png" class="width-48" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('rentalDetails.title_5')}}</span><br>
                    <span class="orange-color almarai-bold">{{value.property.rentalTerm}} {{value.rentalUnits[value.property.rentalUnit]}} </span>
                  </div>
                </div>
              </div>
              <div class="col" v-if="rows && rows.length">
                <div class="row">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-calendar.png" class="width-48" alt="">
                  </div>
                  <div class="col" v-for="(row, index) in rows" :key="index">
                    <span class="text-style">{{$t('rentalDetails.title_6')}}</span><br>
                    <span  class="gray-color-60 almarai-bold">{{moment(row.dueDate).format('DD / MM /YYYY')}}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="!isLoading">
              <div class="col" v-if="value.property.totalDueAmount && parseFloat(value.property.totalDueAmount)">
                <div class="row pt-2">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-7.png" class="width-48" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('rentalDetails.title_7')}}</span><br>
                    <span class="brown-color almarai-bold">{{value.property.totalDueAmount}} <span class="mx-1 brown-color icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
              <div class="col" v-if="value.property.rentExpire" >
                <div class="row">
                  <div class="col-auto p-0">
                  <img src="/assets/images/icons/Frame-6.png" class="width-48" alt="">
                </div>
                <div class="col-auto">
                  <span class="text-style">{{$t('rentalDetails.title_8')}}</span><br>
                  <span class="almarai-bold">{{moment(value.property.rentExpire).format('DD / MM /YYYY')}}</span>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end:Property details owner -->

        <!-- begin:myadvertisement details owner -->
        <div class="row" v-if="myadvertisement && management">
          <div class="col">
            <div class="row pt-3">
              <div class="col">
                <!-- <div class="row pt-3">
                  <div class="col-12 col-md-8 button-center">
                    <div class="gray-color d-flex fonttext-14 pt-1">
                      <i class="fa-solid fa-location-dot pt-1"></i>
                      <div class="me-1">{{value.property.City.name}}</div>
                      <div class="mx-1">{{value.property.Neighborhood.name}}</div>
                    </div>
                  </div>
                </div>
                <hr class="line-color"> -->

                <!-- <div class="row pt-3">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-8.png" class="width-48" alt="">
                  </div>
                  <div class="col">
                    <h6 class="almarai-regular mb-0 fonttext-14 gray-color">{{$t('rentalDetails.title_1')}}</h6>
                    <div class="text-style-green">{{value.statusChoices[value.property.status]}}</div>
                  </div>
                </div> -->

                <div class="row pt-3">
                  <div class="col">
                    <!-- <div class="row pt-3" v-if="Agent">
                      <div class="almarai-bold py-2">{{$t('propertydetails.AdvertiserInformation')}}</div>
                      <div class="col-3 col-md-auto" v-if="Agent.avatar">
                        <div class="agent-logo">
                          <img :src="MEDIA_URL+Agent.avatar" class="w-100" alt="">
                        </div>
                      </div>
                      <div v-else class="col-3 col-md-auto">
                        <div class="agent-logo">
                          <img src="/assets/images/icons/image.png" class="w-100" alt="">
                        </div>
                      </div>
                      <div class="col-4 col-md-auto content-end">
                        <div class="almarai-regular">
                          <span>{{Agent.name}}</span>
                          <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt="">
                        </div>
                        <span class="almarai-regular agent-color">{{$t('propertydetails.title_10')}}</span>
                      </div>
                      <div class="col content-end text-start">
                        <span class="mx-2">
                          <a :href="'https://wa.me/+966'+Agent.mobile.substring(1)">
                            <img src="/assets/images/Frame-whatsapp.png" class="img-fluid" alt="">
                          </a>
                        </span>
                        <span class="mx-2">
                          <a :href="'tel:'+Agent.mobile">
                            <img src="/assets/images/Frame-call.png" class="img-fluid" alt="">
                          </a>
                        </span>
                      </div>
                    </div> -->

                    <!-- begin:ownerData -->
                    <!-- <div class="row pt-3">
                      <div class="almarai-bold py-2">{{$t('propertydetails.ownerName')}}</div>
                      <div class="col-auto col-md-auto" v-if="adCreator.avatar">
                        <div class="agent-logo">
                          <img :src="MEDIA_URL+adCreator.avatar" class="w-100" alt="">
                        </div>
                      </div>
                      <div v-else class="col-auto col-md-auto">
                        <div class="agent-logo">
                          <img src="/assets/images/icons/image.png" class="w-100" alt="">
                        </div>
                      </div>
                      <div class="col-auto p-0 col-md-auto content-end">
                        <div class="almarai-regular">
                          <span>{{adCreator.name}}</span>
                          <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt="">
                        </div>
                        <span class="almarai-regular agent-color">{{$t('propertydetails.ownerName')}}</span>
                      </div>
                      <div class="col text-direction">
                        <span class="ms-2">
                          <a :href="'https://wa.me/+966'+adCreator.mobile.substring(1)">
                            <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                          </a>
                        </span>
                        <span>
                          <a :href="'tel:'+adCreator.mobile">
                            <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                          </a>
                        </span>
                      </div>
                    </div> -->
                    <!-- end:ownerData -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <h6 class="almarai-bold pt-3">{{$t('rentalDetails.title_2')}}</h6> -->
            <!-- <div class="row pt-3 justify-content-between" v-if="!isLoading">
              <div class="col">
                <div class="row pt-2">
                  <div class="col-auto">
                    <img src="/assets/images/icons/Frame-8.png" class="width-48" alt="">
                  </div>
                  <div class="col" v-if="value.property.collectedAmount">
                    <span class="text-style">{{$t('rentalDetails.title_3')}}</span><br>
                    <span class="green-2B almarai-bold">{{value.property.collectedAmount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
              <div class="col" v-if="value.property.remainingPayments">
                <div class="row">
                  <div class="col-auto">
                    <img src="/assets/images/icons/Frame-5.png" class="width-48" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('rentalDetails.title_4')}}</span><br>
                    <span class="gray-color-60 almarai-bold">{{value.property.remainingPayments}} <span class="mx-1 icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- <div class="row py-4" v-if="!isLoading">
              <div class="col" v-if="value.property.rentalTerm">
                <div class="row">
                  <div class="col-auto">
                    <img src="/assets/images/icons/Frame-calendar-2.png" class="width-48" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('rentalDetails.title_5')}}</span><br>
                    <span class="orange-color almarai-bold">{{value.property.rentalTerm}} {{value.rentalUnits[value.property.rentalUnit]}} </span>
                  </div>
                </div>
              </div>
              <div class="col" v-if="rows.length">
                <div class="row">
                  <div class="col-auto">
                    <img src="/assets/images/icons/Frame-calendar.png" class="width-48" alt="">
                  </div>
                  <div class="col" v-for="(row, index) in rows" :key="index">
                    <span class="text-style">{{$t('rentalDetails.title_6')}}</span><br>
                    <span  class="gray-color-60 almarai-bold">{{moment(row.dueDate).format('DD / MM /YYYY')}}</span>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- <div class="row" v-if="!isLoading">
              <div class="col" v-if="value.property.totalDueAmount">
                <div class="row pt-2">
                  <div class="col-auto">
                    <img src="/assets/images/icons/Frame-7.png" class="width-48" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('rentalDetails.title_7')}}</span><br>
                    <span class="brown-color almarai-bold">{{value.property.totalDueAmount}} <span class="mx-1 brown-color icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
              <div class="col" v-if="value.property.rentExpire" >
                <div class="row">
                  <div class="col-auto">
                  <img src="/assets/images/icons/Frame-6.png" class="width-48" alt="">
                </div>
                <div class="col-auto">
                  <span class="text-style">{{$t('rentalDetails.title_8')}}</span><br>
                  <span class="almarai-bold">{{moment(value.property.rentExpire).format('DD / MM /YYYY')}}</span>
                </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>

        <!-- end:myadvertisement details owner -->
        <div class="row mt-5" v-if="billUrl">
          <div class="col">
            <a :href="BASE_URL+billUrl" target="_blank" type="application/pdf">
              <div>
                <img src="/assets/images/icons/receipt-text.png" class="max-22" alt="">
                <span class="mx-2">{{$t('invoiceDetails')}}</span>
              </div>
            </a>
          </div>
        </div>

        <!--begin:location-->
        <div class="row pt-4" v-if="value.property.latitude && value.property.longitude && parseFloat(value.property.latitude) && parseFloat(value.property.longitude)">
          <div class="col">
            <div class="text-center">{{$t('hopeLocation')}}</div>
            <div class="almarai-bold py-2">{{$t('propertydetails.title_14')}}</div>
            <div ref="myMap" style="width: 100%; height: 350px;"></div>
          </div>
        </div>
        <!--end:location-->

        <!-- begin: lawyer Requested & Contact customer service & finance Request -->
        <div class="row" v-if="!management && !myadvertisement">
          <div class="col">
            <div class="row pt-4 justify-content-center">
              <div class="col-6 col-md-6 contact-S">
                <a :href="`https://wa.me/+966920016962?text=${customer_ServiceMessage}`" target="_blank">
                  <div class="card contactService">
                    <div class="card-body">
                      <!-- <div>
                        <img src="/assets/images/icons/call-calling.png" alt="">
                      </div>
                      <div>{{$t('contactService')}} {{$t('customers')}}</div> -->
                      <div class="d-block d-md-none">
                        <img src="/assets/images/icons/call-calling.png" alt="">
                      </div>
                      <span class="d-none d-md-block">
                        <img src="/assets/images/icons/call-calling.png" alt="">
                        <span class="mx-2">{{$t('contactService')}} {{$t('customers')}}</span>
                      </span>
                      <div class="d-block d-md-none">{{$t('contactService')}} {{$t('customers')}}</div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-6 col-md-6" v-if="GET_USER">
                <router-link :to="'/lawyerRequested/'+propertyId+'?propertyType=property'">
                  <div class="card contactLawyer">
                    <div class="card-body">
                      <div class="row justify-content-center">
                        <div class="col-auto d-block d-md-none content-center text-center">
                          <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                        </div>
                        <div class="almarai-bold d-block d-md-none">{{$t('contactLawyer')}}</div>
                        <span class="d-none lawyer-style d-md-block">
                          <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                          <span class="mx-2">{{$t('contactLawyer')}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div v-else class="col-6 col-md-6">
                <div class="card contactLawyer" @click="poupLogin">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-auto d-block d-md-none content-center text-center">
                        <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                      </div>
                      <div class="almarai-bold d-block d-md-none">{{$t('contactLawyer')}}</div>
                      <span class="d-none lawyer-style d-md-block">
                        <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                        <span class="mx-2">{{$t('contactLawyer')}}</span>
                      </span>
                      <!-- <div class="col-auto content-center text-center">
                        <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                      </div>
                      <div>{{$t('contactLawyer')}}</div> -->
                      <!-- <div class="col-8 content-center">
                        <div v-if="lawyerPrice"> 
                          <span>{{$t('lawyerNow')}}</span>
                          <span class="mx-1 almarai-bold green-color-F">{{lawyerPrice}}</span> 
                          <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span> 
                        </div>
                      </div> -->
                      <!-- <div class="col-auto button-center ps-0">
                        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-4 financeOrder">
              <div class="col-12 col-md-6">
                <div class="card br-radius">
                  <div class="card-body">
                    <div class="almarai-bold font-20">{{$t('discountCoupon')}}</div>
                    <!-- <div class="gray-color-76">{{$t('getDiscount')}}</div> -->
                  </div>
                  <div class="row justify-content-center py-2">
                    <div class="col-11 poistion-R">
                        <img src="/assets/images/icons/ticket-1.png" class="ticket" alt="">
                        <input type="text" v-model="coupon"  class="form-control input-style ticket-input" :placeholder="$t('couponCode')">
                        <loader v-if="loading" />
                        <span v-else class="btn-Ticket" @click="checkProperty">{{$t('application')}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 fields">
                <div class="card requestFinance">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-8 col-md-8 finance_text">
                        <div>{{$t('needFinancing')}}</div>
                        <div>{{$t('manageObligations')}}</div>
                        <div class="row pt-3 finance_text">
                          <div class="col-9 col-md-5 btn_requestFinance">
                            <router-link :to="'/createfinance/'+propertyId">
                            <span class="text_btn">{{$t('ApplyFnancing')}}</span>
                            </router-link>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-4 content-center text-direction">
                        <img src="/assets/images/Vector.png" class="img_requestFinance" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end: lawyer Requested & Contact customer service & finance Request -->

        <!-- begin: lawyer Requested & Contact customer service & finance Request -- myadvertisement || management -->
        <div class="row" v-if="management || myadvertisement">
          <div class="col">
            <div class="row pt-4 justify-content-center">
              <div class="col-6 col-md-6 contact-S">
                <a :href="`https://wa.me/+966920016962?text= ${customer_ServiceMessage}`" target="_blank">
                  <div class="card contactService">
                    <div class="card-body">
                      <!-- <div>
                        <img src="/assets/images/icons/call-calling.png" class="max-40" alt="">
                      </div>
                      <div>{{$t('contactService')}} {{$t('customers')}}</div> -->
                      <div class="d-block d-md-none">
                        <img src="/assets/images/icons/call-calling.png" alt="">
                      </div>
                      <span class="d-none d-md-block">
                        <img src="/assets/images/icons/call-calling.png" alt="">
                        <span class="mx-2">{{$t('contactService')}} {{$t('customers')}}</span>
                      </span>
                      <div class="d-block d-md-none">{{$t('contactService')}} {{$t('customers')}}</div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-6 col-md-6" v-if="GET_USER">
                <router-link :to="'/lawyerRequested/'+propertyId+'?propertyType=property'">
                  <div class="card contactLawyer">
                    <div class="card-body">
                      <div class="row justify-content-center">
                        <div class="col-auto d-block d-md-none content-center text-center">
                          <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                        </div>
                        <div class="almarai-bold d-block d-md-none">{{$t('contactLawyer')}}</div>
                        <span class="d-none lawyer-style d-md-block">
                          <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                          <span class="mx-2">{{$t('contactLawyer')}}</span>
                        </span>
                        <!-- <div class="col-auto text-center content-center">
                          <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                        </div>
                        <div>{{$t('contactLawyer')}}</div> -->
                        <!-- <div class="col-8 content-center">
                          <div> 
                            <span>{{$t('lawyerNow')}}</span>
                            <span class="mx-1 almarai-bold green-color-F">{{lawyerPrice}}</span> 
                            <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span> 
                          </div>
                        </div> -->
                        <!-- <div class="col-auto button-center ps-0">
                          <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                          <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div v-else class="col-12 col-md-6">
                <div class="card contactLawyer" @click="poupLogin">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-auto d-block d-md-none content-center text-center">
                        <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                      </div>
                      <div class="almarai-bold d-block d-md-none">{{$t('contactLawyer')}}</div>
                      <span class="d-none lawyer-style d-md-block">
                        <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                        <span class="mx-2">{{$t('contactLawyer')}}</span>
                      </span>
                      <!-- <div class="col-3 content-center">
                        <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                      </div>
                      <div class="col-8 content-center">
                        <div>{{$t('contactLawyer')}}</div>
                        <div v-if="lawyerPrice"> 
                          <span>{{$t('lawyerNow')}}</span>
                          <span class="mx-1 almarai-bold green-color-F">{{lawyerPrice}}</span> 
                          <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span> 
                        </div>
                      </div>
                      <div class="col-auto button-center ps-0">
                        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-4 financeOrder">
              <div class="col-12 fields">
                <div class="card requestFinance">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-8 col-md-8 finance_text">
                        <div>{{$t('needFinancing')}}</div>
                        <div>{{$t('manageObligations')}}</div>
                        <div class="row pt-3 finance_text">
                          <div class="col-9 col-md-5 btn_requestFinance">
                            <router-link :to="'/createfinance/'+propertyId">
                            <span class="text_btn">{{$t('ApplyFnancing')}}</span>
                            </router-link>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 col-md-4 content-center text-direction">
                        <img src="/assets/images/Vector.png" class="img_requestFinance" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end: lawyer Requested & Contact customer service & finance Request -->
        <div v-if="advertisement" class="row pt-3">
          <div class="col-12">
            <div class="almarai-bold">{{$t('ReliableInformation')}}:</div>
          </div>
          <div class="col-12">
            <div class="row pt-2">
              <div class="col-12 col-md-8">
                <div class="row">
                  <div class="col-6 col-md-4 mb-3">
                    <div class="fontGray-73 almarai-bold">{{$t('advertisements.fal')}}:</div>
                    <div v-if="advertisement.brokerageAndMarketingLicenseNumber" class="gray-color-60">{{advertisement.brokerageAndMarketingLicenseNumber}}</div>
                    <div v-else>-</div>
                  </div>
                  <div class="col-6 col-md-4 mb-3">
                    <div class="fontGray-73 almarai-bold">{{$t('adLicenseNumber')}}:</div>
                    <div v-if="advertisement.adLicenseNumber" class="gray-color-60">{{advertisement.adLicenseNumber}}</div>
                    <div v-else>-</div>
                  </div>
                  <div class="col-6 col-md-4 mb-3">
                    <div class="fontGray-73 almarai-bold">{{$t('creationDate')}}:</div>
                    <div v-if="advertisement.creationDate" class="gray-color-60">{{advertisement.creationDate}}</div>
                    <div v-else>-</div>
                  </div>
                  <div class="col-6 col-md-4 mb-3">
                    <div class="fontGray-73 almarai-bold">{{$t('advertisements.endDate')}}:</div>
                    <div v-if="advertisement.endDate" class="gray-color-60">{{advertisement.endDate}}</div>
                    <div v-else></div>
                  </div>
                  <div class="col-6 col-md-4 mb-3">
                    <div class="fontGray-73 almarai-bold">{{$t('advertisements.propertyUsages')}}:</div>
                    <div v-if="advertisement.propertyUsages.join(', ')" class="gray-color-60">{{advertisement.propertyUsages.join(', ')}}</div>
                    <div v-else>-</div>
                  </div>
                  <div class="col-6 col-md-4 mb-3">
                    <div class="fontGray-73 almarai-bold">{{$t('advertisements.guaranteesAndTheirDuration')}}:</div>
                    <div v-if="advertisement.guaranteesAndTheirDuration" class="gray-color-60">{{advertisement.guaranteesAndTheirDuration}}</div>
                    <div v-else>-</div>
                  </div>
                  <div class="col-6 col-md-4 mb-3">
                    <div class="fontGray-73 almarai-bold">{{$t('advertisements.obligationsOnTheProperty')}}:</div>
                    <div v-if="advertisement.obligationsOnTheProperty" class="gray-color-60">{{advertisement.obligationsOnTheProperty}}</div>
                    <div v-else>-</div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 position-R">
                <a :href="advertisement.adLicenseUrl" class="license-url">
                  <img v-if="qrLink" :src="`${MEDIA_URL}${qrLink}`" style="width: 100px;" alt="">
                  <div class="fontGray-73 almarai-bold">{{ $t('advertisements.detailsLink') }}</div>
                  <span class="export_Icons">
                    <img src="/assets/images/export.png" style="width: 30px;" alt="">
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- begin:Property details -->
        <div class="row pt-3" v-if="!management">
          <div class="col">
            <div class="row pb-4" v-if=" propertyStatus == 'available'">
              <router-link :to="'/advertismentReport/?rowId='+this.propertyId">
                <div class="col text-start">
                  <div class="padding-style almarai-bold">
                    <i class="fa-regular fa-font-awesome red-color"></i>
                    <span class="mx-2">{{$t('propertydetails.reportAd')}}</span>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="card shadow-card">
              <div class="card-body">
                <div class="row justify-content-around">
                  <div class="col-12 col-md-6 content-center">
                    <div class="row">
                      <div class="col almarai-bold content-center">
                        {{$t('totalPrice')}}
                      </div>
                      <div class="col-auto almarai-bold">
                        <span class="green-color-F">
                          <!-- {{(advertisement)? (advertisement.landTotalPrice)? parseFloat(advertisement.landTotalPrice).toLocaleString() : parseFloat(advertisement.propertyPrice).toLocaleString() : price}} -->
                          {{price}}
                        </span> 
                        <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pt-2 justify-content-center">
                  <div class="col-12 col-md-5 fields d-block d-lg-none mb-2">
                    <div class="row justify-content-center">
                      <div v-if="GET_USER && value.isOwner !=true && status !='under_review'" class="col-12 col-md-9 mouse-hand">
                        <div @click="propertyReservation" class="almarai-bold En-style btn-black  text-center">{{$t('propertydetails.title_11')}}</div>
                      </div>
                      <div v-if="!GET_USER" class="col-12 col-md-9 mouse-hand">
                        <div @click="poupLogin" class="almarai-bold En-style submit-button text-center">{{$t('propertydetails.title_11')}}</div>
                      </div>
                    </div>
                  </div>

                  <div v-if="GET_USER && value.isOwner !=true" class="col-12 col-md-4 mouse-hand">
                    <router-link :to="'/propertypreview/'+propertyId">
                      <div class="btn-green">{{$t('propertydetails.title_12')}}</div>
                    </router-link>
                  </div>
                  <div v-if="!GET_USER && value.isOwner !=true" class="col-12 col-md-4 mouse-hand">
                    <div @click="poupLogin" class="almarai-bold En-style btn-green">{{$t('propertydetails.title_12')}}</div>
                  </div>

                  <div class="col-12 col-md-5 fields d-none d-lg-block">
                    <div class="row justify-content-center">
                      <div v-if="GET_USER && value.isOwner !=true && status !='under_review'" class="col-12 col-md-9 mouse-hand">
                        <div @click="propertyReservation" class="almarai-bold En-style btn-black  text-center">{{$t('propertydetails.title_11')}}</div>
                      </div>
                      <div v-if="!GET_USER" class="col-12 col-md-9 mouse-hand">
                        <div @click="poupLogin" class="almarai-bold En-style submit-button text-center">{{$t('propertydetails.title_11')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end:Property details -->

        <!-- begin:Property details owner -->
        <div class="row" v-if="management">
          <div class="col">
            <section class="pt-3">
              <div class="row">
                <div class="col">
                  <h5 class="almarai-bold">{{$t('propertydetails.propertyDocuments')}}</h5>
                </div>
                <div class="col-auto viewDoc" v-if="propertyAttachments.length" @click="viewDocuments">
                  <span class="mx-2">{{$t('property.viewDocuments')}}</span>
                  <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                  <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                </div>
              </div>
              <div class="row pt-4">
                <div class="col">
                  <div class="row">
                    <div class="col-auto ps-0">
                      <img src="/assets/images/icons/Frame-4.png" class="width-40" alt="">
                    </div>
                    <div class="col pe-0">
                      <div class="mx-2 text-style">{{$t('propertydetails.deedNumber')}}</div>
                      <div v-if="PropertyOwner.receiptNumber" class="pe-2">{{PropertyOwner.receiptNumber}}</div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col-auto ps-0">
                      <img src="/assets/images/icons/Frame-3.png" class="width-40" alt="">
                    </div>
                    <div class="col pe-0" @click.prevent="identityImageOpen">
                      <div class="text-style mx-2">{{$t('propertydetails.identityImage')}}</div>
                      <div class="orange-color pe-2 almarai-bold">{{$t('propertydetails.Viewimage')}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row py-4">
                <div class="col">
                  <div class="row">
                    <div class="col-auto ps-0">
                      <img src="/assets/images/icons/Frame-2.png" class="width-40" alt="">
                    </div>
                    <div class="col pe-0">
                      <div class="mx-2 text-style">{{$t('propertydetails.buildingLicence')}}</div>
                      <div class="pe-2 almarai-bold orange-color">{{$t('propertydetails.viewLicence')}}</div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col-auto ps-0">
                      <img src="/assets/images/icons/Frame-413.png" class="width-40" alt="">
                    </div>
                    <div class="col pe-0">
                      <div class="text-style mx-2">{{$t('propertydetails.civilDefense')}}</div>
                      <div class="orange-color pe-2 almarai-bold">{{$t('propertydetails.viewcertificate')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div class="row pt-5 justify-content-center">
              <!-- <div class="col"  data-bs-toggle="modal" data-bs-target="#paymentModal">
                <div class="btn-black" >ادفع إيجارك</div>
              </div> -->
              <div class="col-11 col-md-5"  data-bs-toggle="modal" data-bs-target="#exampleModal">
                <div class="btn-golden">{{$t('propertydetails.newMaintenance')}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- end:Property details owner -->

        

        <!--begin:modalPropertyreservation-->
        <div class="modal bg-modal" tabindex="-1" id="modalreservation">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="" dir="ltr">
                <button type="button" @click="closeForm" class="btn-close p-3" data-bs-dismiss="modal" aria-label="Close"></button>
                <h5 class="modal-title text-center font-24 almarai-bold">{{$t('propertydetails.title_11')}}</h5>
              </div>
              <div class="modal-body text-center">
                <!-- <div class="row">
                  <div class="col almarai-regular gray-color">
                    <div>{{$t('propertydetails.title_21')}}</div>
                    <div>{{$t('propertydetails.title_22')}}</div>
                  </div>
                </div> -->
                <div class="row">
                  <div class="col almarai-regular gray-color">
                    <div>{{$t('propertydetails.title_23')}}</div>
                    <!-- <div>{{$t('propertydetails.title_24')}}</div> -->
                  </div>
                </div>
              </div>
              <div class="row py-3 justify-content-center">
                <div class="col-10" v-if="!isLoading">
                  <router-link :to="'/propertyreservation/'+propertyId+'?coupon='+coupon">
                  <div class="submit-button text-center">{{$t('propertydetails.title_11')}}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end:modalPropertyreservation-->

        <!-- Modal-begin:maintenances -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <!-- <div class="modal-header">
                <button type="button" class="btn-close" id="maintenanceClose" data-bs-dismiss="modal" aria-label="Close"></button>
              </div> -->
              <div class="modal-body">
                <div class="row pt-3">
                  <router-link to="/maintenances/?type=global" @click="exitForm">
                    <div class="col btn-white">
                      <div class="almarai-bold">{{$t('Free_owners_tenants')}}</div>
                      <span class="text-center almarai-regular text-style">{{$t('dedicated_Maintenance')}}</span>
                    </div>
                  </router-link>
                </div>

                <div class="row pt-3">
                  <router-link to="/maintenances/?type=normal" @click="exitForm">
                    <div class="col btn-black">
                      <div class=" almarai-bold">{{$t('requestMaintenance')}}</div>
                      <span class="text-center almarai-regular text-white">
                        {{$t('Within_24hours')}} {{normalOrderPrice}} {{$t('addAd.real')}}
                      </span>
                    </div>
                  </router-link>
                </div>

                <div class="row pt-3">
                  <router-link to="/maintenances/?type=fast" @click="exitForm">
                    <div class="col btn-white">
                      <div class=" almarai-bold">{{$t('requestExpress_maintenance')}}</div>
                      <span class="text-center almarai-regular text-style">
                        {{$t('Within_120Minutes')}} {{fastOrderPrice}} {{$t('addAd.real')}}
                      </span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal-end:maintenances -->
        
      </div>
    </div>




    <!-- begin:modal-payment -->
    <!-- <div class="modal fade d-none" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0 pb-1">
            <h5 class="almarai-bold">دفع الايجار</h5>
            <button type="button" id="closeModal" class="btn-close p-3 ms-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="row">
            <div class="col mx-3">
              <span>قيمة دقعة الايجار</span> <br>
              <div class="d-flex fonttext-14 pt-1">
                <span class="almarai-bold" v-for="(rent, R_index) in availableForPay" :key="R_index">{{rent.amount}}</span>
                <span class="mx-1 almarai-bold">{{$t('currency')}}</span>
                <span class="mx-1 almarai-bold">فقط لاغير</span>
              </div>
            </div>
          </div>
          <div class="modal-body pt-2">
            <div class="row" v-if="form =='installmentList'">
              <div class="col">
                <div class="card mb-3 installment" 
                  v-for="(rent, key) in availableForPay" :key="key"
                >
                  <label class="form-check-label" :for="`Rent_${rent.id}`">
                    <div :class="(installment_Id == rent.id)? 'card-body installment-selected' : 'card-body'">
                      <div class="row">
                        <div class="col">
                          <input class="form-check-input" @change="payRent" type="radio" v-model="installment_Id" :value="rent.id" name="radioDefault" :id="`Rent_${rent.id}`">
                          <span class="almarai-bold">الدفعات القادمة :</span>
                          <span class="mx-1 almarai-bold">{{rent.amount}}</span>
                          <span class="mx-1 icon-saudi_riyal_bold_new"></span>
                          <div class="gray-color">
                            <span> تاريخ الاستحقاق:</span>
                            <span class="mx-2">{{moment(rent.dueDate).format('DD / MM / YYYY')}}</span>
                          </div>
                        </div>
                        <div class="col-auto button-center">
                          <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                          <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <div class="card border-0" v-if="form == 'payment'">
              <div class="card-body">
                <h1 class="modal-title fs-5 almarai-bold" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
                <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
                <div class="row pt-3 justify-content-center">
                  <div class="col-11 position-R">
                    <label for="visa" class=" mouse-hand d-block">
                      <div class="input-style">
                        <input class="form-check-input radio-left" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                        <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                        <span class="mx-2">{{$t('wallet.title_14')}}</span>
                      </div>
                    </label>
                  </div>
                </div>

                <div class="row pt-3 justify-content-center">
                  <div class="col-11 position-R">
                    <label for="radioDefault1" class=" mouse-hand d-block">
                      <div class="input-style">
                        <input class="form-check-input radio-left" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                        <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                        <span class="mx-2">{{$t('wallet.title_16')}}</span>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="row pt-5">
                  <div class="text-center" v-if="loadingPay">
                    <loader />
                  </div>
                  <div v-else class="col mouse-hand" @click.prevent="payInstallment">
                    <div class="buttonStyle padding-style almarai-bold form-control">{{$t('wallet.title_15')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- end:modal-payment -->


    <!-- Button trigger modal -->
    <button type="button" id="modalSuccess" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#successPayment">
    </button>

    <!-- Modal -->
    <div class="modal fade" id="successPayment" tabindex="-1" aria-labelledby="successPaymentLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close ms-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center">
            <div class="row justify-content-center pt-3">
              <div class="col-12 text-center">
                <img src="/assets/images/tick-circle.png" alt="">
              </div>
            </div>
            <div class="row">
              <div class="col">
                {{$t('successfullyPaid')}}
              </div>
            </div>
          </div>
          <div class="row justify-content-center py-3">
              <div class="col-8 btn-black text-center">
                <router-link to="/">
                <div class="text-white">{{$t('homepage')}}</div>
                </router-link>
              </div>
          </div>
        </div>
      </div>
    </div>

    <!-- begin:identityImage -->
    <button type="button" id="btnidentityImage" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#identityImage">
    </button>

    <!-- Modal -->
    <div class="modal fade" id="identityImage" tabindex="-1" aria-labelledby="identityImageLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
              <img v-if="management && PropertyOwner.identityImage" :src="MEDIA_URL+PropertyOwner.identityImage" alt="">
            <div v-else class="row pt-3 justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/Frame.png" class="w-prcentage-12" alt="">
                <h6 class="pt-2">{{$t('dataAvailable')}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:identityImage -->

    <div class="modal bg-modal" tabindex="-1" id="propertyFeatures">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('propertyFeatures')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" @click="close_PropertyFeatures" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="row pt-3" v-if="propertyFeatures.length">
              <div class="col-auto text-center align-content-center mb-3"
                v-for="(featured,index) in propertyFeatures" :key="index">
                <div class="card borderCard">
                  <div class="card-body">
                    <div>
                      <img :src="MEDIA_URL+featured.icon" class="max-width-28" alt="">
                    </div>
                    <div class="gray-color almarai-regular">{{featured.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- begin: view documents -->
    <div class="modal bg-modal" tabindex="-1" id="viewDocumentsPopup">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                <span class="mx-2 fonttext-14">{{$t('property.viewDocuments')}}</span>
              </div>
              <div class="col-auto mouse-hand" id="closeModal" @click="close_Popup" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="row pt-3" v-if="propertyAttachments && propertyAttachments.length">
              <div class="col content-center">
                <div class="row mb-3" v-for="(pro,index) in propertyAttachments" :key="index">
                  <div class="col content-center">
                    <div class="gray-color almarai-bold">{{pro.name}}</div>
                    <!-- <div class="card borderCard">
                      <div class="card-body">
                        <div>
                          <img :src="MEDIA_URL+featured.icon" class="max-width-28" alt="">
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="col-auto btn-gold-samll" v-if="pro.fileType == 'pdf'">
                    <a :href="MEDIA_URL+pro.path" class="text-white" target="_blank">
                      <span class="mx-2">{{$t('viewDocuments')}}</span>
                    </a>
                  </div>
                  <div v-else class="col-auto btn-gold-samll" @click="openViewDocument">
                    <span class="mx-2">{{$t('viewDocuments')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: view documents -->

    <!-- begin: view documents image  -->
    <div class="modal bg-modal" tabindex="-1" id="viewImage">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                <span class="mx-2 fonttext-14">{{$t('property.viewDocuments')}}</span>
              </div>
              <div class="col-auto mouse-hand" id="closeModal" @click="closePopup" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="row pt-3 justify-content-center" v-if="propertyAttachments && propertyAttachments.length">
              <div class="col-12 mb-3 text-center content-center" v-for="(prop,indxf) in propertyAttachments" :key="indxf" >
                <img v-if="prop.fileType == 'image'" :src="MEDIA_URL+prop.path" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: view documents image -->

    <!-- Modal:begin couponPopup -->
    <div class="modal" id="coupon_popup" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="text-center"><img src="/assets/images/icons/new-success.png" class="w-25" alt=""></div>
              <div class="row pt-2">
                <div class="col">{{$t('price_beforeDiscount')}}</div>
                <div class="col-auto almarai-bold">{{originalPrice}}</div>
              </div>
              <div class="row pt-2">
                <div class="col">{{$t('priceAfterDiscount')}}</div>
                <div class="col-auto almarai-bold">{{priceAfterDiscount}}</div>
              </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-8">
                <div type="button" class="btn-black" @click="closeCoupon">{{$t('maintenances.title_21')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:couponPopup -->
    <!--begin:modal login-->
    <div class="modal bg-modal" tabindex="-1" id="mustLogin">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-auto mouse-hand" @click.prevent="closeingFN">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="loginTitle">
                  {{$t("formLogin.title_1")}}
                </div>
                <p class="fontGray-73 mb-1 pt-1">
                  {{$t("formLogin.title_2")}} <br />
                  {{$t("formLogin.title_3")}}
                </p>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-8 mb-2">
                <router-link to="/login">
                  <button class="form-control btn-green">
                    {{$t("formLogin.title_4")}}
                  </button>
                </router-link>
              </div>
              <div class="col-12 col-md-8 pt-1">
                <router-link to="/register">
                  <button class="form-control btn-black">
                    {{ $t("formLogin.title_5") }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->
  </div>
</template>

<script>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import { Pagination, Navigation, FreeMode, Thumbs,Autoplay  } from "swiper/modules";
import { mapGetters } from "vuex";
import FsLightbox from "fslightbox-vue";
import { toast } from '@/helpers/tools';
import { setSEO } from '@/helpers/seo';
import moment from 'moment';

export default {
  name:"propertydetails",
  components: { Swiper, SwiperSlide,FsLightbox },
  computed:{
    ...mapGetters(["GET_USER",'MEDIA_URL', 'BASE_URL', 'CHAT_CLIENT', 'FRONTEND_URL'])
  },
  setup(){
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };
    return {
      thumbsSwiper,
      setThumbsSwiper,
      modules: [FreeMode, Thumbs, Navigation, Pagination,Autoplay ],
    }
  },
  data(){
    return {  
      message: "",
      hasError: false,
      errorNumber: 0,
      propertyId: this.$route.params.id,
      propertyType: this.$route.query.propertyType ?? 'property',
      management: (this.$route.query.m && this.$route.query.m == '1')? true: false,
      myadvertisement: (this.$route.query.a && this.$route.query.a == '1')? true: false,
      isLoading: true,
      value : {},
      map: null,
      marker: null,
      icons: {},
      images: [],
      lightboxToggler: false,
      lightboxIndex: 0,
      Agent: {},
      adCreator: {},
      userLang: 'ar',
      propertyStatus: "",
      purpose: "",
      showMessage: false,
      rows: [],
      PropertyOwner: {},
      User: {},
      adLicenseNumber: {},
      billUrl: null,
      lawyerPrice: null,
      sendChatDisabled: false,
      propertyFeatures: [],
      staus: {},
      advertisement: null,
      qrLink: null,
      coupon: "",
      loading: false,
      priceAfterDiscount: null,
      originalPrice: null,
      propertyAdditional: null,
      fastOrderPrice: null,
      normalOrderPrice: null,
      propertyAttachments: [],
      whatsAppTextPublic: `${this.FRONTEND_URL}/propertydetails/${this.$route.params.id}?propertyType=property&v=1`,
      whatsAppTextPrivate: `${this.FRONTEND_URL}/propertydetails/${this.$route.params.id}?propertyType=property&v=1`,
      price: null,
      customer_ServiceMessage: this.$t('customer_ServiceMessage'),
    }
  },
  
  methods: {
    getRetrieve(){
      this.hasError = false;
      let url = "/api/properties/retrieve/"+this.propertyId;
      if(this.management)
        url = url + '?management=1';
      if(this.myadvertisement && !this.management)
        url = url + '?management=1'
      this.$http.get(url).then(res => {
        // console.log(res);
        const propertyRow = res.data.property;
        const mainImage = (propertyRow.mediaFiles.length)? this.MEDIA_URL + propertyRow.mediaFiles[0].thumbnail : null;
        setSEO({
          title: propertyRow.title, description: propertyRow.description, 
          image: mainImage, url: window.location.href
        });
        this.value = res.data;
        this.Agent = res.data.property.Agent;
        this.User = res.data.property.User;
        this.price = res.data.property.price;
        this.adCreator = res.data.property.adCreator.User;
        this.adLicenseNumber = res.data.property.adCreator.adLicenseNumber;
        this.icons = res.data.countedIcons;
        this.propertyStatus = res.data.property.status;
        this.purpose = res.data.property.purpose;
        this.rows = res.data.property.NextPayment;
        this.PropertyOwner = res.data.property.PropertyOwner;
        this.propertyFeatures = res.data.property.PropertyFeatures;
        this.status = this.value.property.status;
        this.advertisement = (res.data.property.AdValidator)? res.data.property.AdValidator.advertisement : null;
        this.qrLink = (res.data.property.AdValidator)? res.data.property.AdValidator.qrLink : null;
        this.propertyAdditional = this.value.property.PropertyAdditional ?? null;
        this.propertyAttachments = this.value.property.PropertyAttachments ?? null;
        if(this.value.property.latitude && this.value.property.longitude){
          this.initialGoogleMap();
        }

        if(res.data.property.mediaFiles){
          for(let i=0; i < res.data.property.mediaFiles.length; i++){
            this.images.push(this.MEDIA_URL+res.data.property.mediaFiles[i].filePath);
          }
        }

        if(this.GET_USER)
          this.lawyerRequestPrice();
          window.scroll(0,0);
        // console.log(this.value.isOwner);
      this.getOrderinitial();
        this.whatsAppTextPublic = `${this.FRONTEND_URL}/propertydetails/${this.$route.params.id}?propertyType=property&v=1 
        ${res.data.property.PropertyType?.name} ${(res.data.property.purpose == 'for_sale')? 'للبيع' : 'للإيجار'} 
        ${res.data.property.Region?.name} ${res.data.property.City?.name} 
        ${(res.data.property.price)? 'السعر '+res.data.property.price : ''}`;
        this.whatsAppTextPrivate = `السلام عليكم
        وجدت إعلانكم في تطبيق عقار المحيسني وأرغب بالتواصل معكم بخصوص الإعلان:
        ${res.data.property.PropertyType?.name} ${(res.data.property.purpose == 'for_sale')? 'للبيع' : 'للإيجار'} 
        ${res.data.property.Region?.name} ${res.data.property.City?.name} 
        ${(res.data.property.price)? 'السعر '+res.data.property.price : ''}

        رابط الإعلان: 
        ${this.FRONTEND_URL}/propertydetails/${this.$route.params.id}?propertyType=property&v=1`;
        this.isLoading = false;
        window.scrollTo({top:0, behavior:'smooth'});
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
      })
    },

    openLightbox(index) {
      this.lightboxIndex = index;
      this.lightboxToggler = !this.lightboxToggler; // Toggle to open
    },

    reservation(){
      if(!this.GET_USER) {
        document.getElementById("mustLogin").style.display = "block";
        return false;
      }else {
        this.$router.push({ path:"/propertypreview/"+this.propertyId });
      }
    },

    closeingFN() {
      document.getElementById("mustLogin").style.display = "none";
    },

    poupLogin(){
      document.getElementById("mustLogin").style.display = "block";
    },

    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.value.property.latitude) ? parseFloat(this.value.property.latitude) :24.7136, 
          lng: (this.value.property.longitude) ? parseFloat(this.value.property.longitude) : 46.6753, 
        },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.value.property.latitude)? parseFloat(this.value.property.latitude) : 24.7136, 
          lng: (this.value.property.longitude) ? parseFloat(this.value.property.longitude) : 46.6753 
        },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
        // console.log(parseFloat(this.value.property.latitude));
    },

    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    propertyReservation(){
      document.getElementById('modalreservation').style.display = 'block';
    },
    closeForm(){
      document.getElementById('modalreservation').style.display ='none';
    },

    addFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('mustLogin').style.display = "block";
        return false;
      }
      this.$http.post("/api/favorites/add",{
        propertyId: id,
      }).then(res => {
        // console.log(res);
        if(dataName == 'value.property.mediaFiles'){
          this.value.property.Favorites = [{}];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    removeFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('mustLogin').style.display = "block";
        return false;
      }
      this.$http.delete("/api/favorites/remove/"+id).then(res => {
        // console.log(res);
        if(dataName == 'value.property.mediaFiles'){
          this.value.property.Favorites = [];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    exitForm(){
      const modal = bootstrap.Modal.getInstance(
        document.getElementById('exampleModal')
      );
      modal.hide();
    },
    moment,
    formatDate(){
      if(this.userLang == 'ar'){
        moment.locale(this.formatedDate);
      }else{
        moment.locale(this.fallbackLang);
      }
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },
    getBill(){
      if(this.GET_USER){
        this.$http.get('/api/bills/Properties/'+this.propertyId).then(res => {
          if(res.data.url)
            this.billUrl = res.data.url
        }).catch(() => {});
      }
    },

    identityImageOpen(){
      document.getElementById('btnidentityImage').click();
    },

    lawyerRequestPrice(){
      this.hasError = false;
      this.$http.post('/api/lawyerReq/init',{
        propertyId: this.propertyId,
        propertyType: this.propertyType, 
      }).then(res => {
        // console.log(res);
        this.lawyerPrice = res.data.price;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    sendChatMessage(){
      if(!this.CHAT_CLIENT){
        toast(this.$t('nav.relgoin'));
        return;
      }

      this.sendChatDisabled = true;
      this.$http.post('/api/chats/createChannel', {
        model: 'properties',
        id: parseInt(this.propertyId),
      }).then(({data}) => {
        if(data.newChat){
          const filter = {type: "messaging", cid: {$eq: `messaging:${data.channelId}`}};
          const sort = [{ last_message_at: -1 }];
          const options = {
            limit: 1, //watch: true,
          };
          this.CHAT_CLIENT.queryChannels(filter, sort, options).then(channel => {
            channel[0].sendMessage({
              text: this.$t('nav.welcome'),
            }).then(() => {
              this.sendChatDisabled = false;
              this.$router.push({path : '/chats', query: { id: data.channelId }});
            }).catch(err => {
              toast(this.$t('nav.chatCantSend'));
              this.sendChatDisabled = false;
            });
          }).catch(err => {
            toast(this.$t('nav.chatCantSend'));
            this.sendChatDisabled = false;
          });
        }else{
          this.sendChatDisabled = false;
          this.$router.push({path : '/chats', query: { id: data.channelId }});
        }
      }).catch(err => {
        const msg = this.$globalError(err);
        toast(msg);
        this.sendChatDisabled = false;
      });
    },
    method_propertyFeatures(){
      document.getElementById('propertyFeatures').style.display = 'block';
    },

    viewDocuments(){
      document.getElementById('viewDocumentsPopup').style.display = 'block';
    },

    openViewDocument(){
      document.getElementById('viewDocumentsPopup').style.display = 'none';
      document.getElementById('viewImage').style.display = 'block';
    },
    closePopup(){
      document.getElementById('viewImage').style.display = 'none';
    },

    close_Popup(){
      document.getElementById('viewDocumentsPopup').style.display = 'none';
    },

    close_PropertyFeatures(){
      document.getElementById('propertyFeatures').style.display = 'none';
    },

    checkProperty(){
      this.loading = true;
      this.$http.post('/api/coupons/checkProperty',{
        propertyId: parseInt(this.propertyId),
        coupon: this.coupon
      }).then(res => {
        // console.log(res);
        this.originalPrice = res.data.originalPrice;
        this.priceAfterDiscount = res.data.priceAfterDiscount;
        document.getElementById('coupon_popup').style.display = "block";
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.loading = false;
      })
    },
    closeCoupon(){
      document.getElementById('coupon_popup').style.display = 'none';
    },

    getOrderinitial(){
      this.hasError = false;
      this.$http.get("/api/orders/init").then(res => {
        // console.log(res);
        this.normalOrderPrice = res.data.normalOrderPrice;
        this.fastOrderPrice = res.data.fastOrderPrice;
        window.scroll(0,0);
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      });
    },
  },
  created(){
    this.getRetrieve();
    this.getBill();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior:'smooth'});
  }
}
</script>
